import React from 'react';
import PropTypes from 'prop-types';

import './modal.css';

const Modal = ({
    showModal,
    closeModal,
    position,
    width,
    children,
    btnCloseModal,
    nameModal,
    nameModalContent
}) => {
    return (
        <div
            id={nameModal}
            className={`pop-up ${showModal && 'show'} ${position && position}`}>
            <div
                id={nameModalContent}
                className={`pop-up-wrapper ${width} ${showModal && 'show'}`}>
                <div className="modal">
                    {btnCloseModal && (
                        <button
                            onClick={closeModal}
                            title="Close"
                            className="close-modal">
                            ×
                        </button>
                    )}

                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
};
Modal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    btnCloseModal: PropTypes.bool,
    position: PropTypes.string,
    width: PropTypes.string,
    children: PropTypes.element,
    nameModal: PropTypes.string,
    nameModalContent: PropTypes.string
};

export default Modal;
